/** @jsxImportSource @emotion/react */
import { css, Theme } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { MdInfoOutline } from 'react-icons/md';

import ModalDialog from 'components/modal';
import { Flex } from 'components/styled';
import Button from 'components/styled/Button';
import Link from 'components/styled/Link';
import Paper from 'components/styled/Paper';
import Text from 'components/styled/Text';
import TitleText from 'components/styled/TitleText';

export const CustomerServiceDialog = () => {
	const { t } = useTranslation('components/tiles/product_tab/index/');
	return (
		<ModalDialog
			label="info"
			control={openModal => (
				<Flex justifyContent="center" px={4}>
					<Text fontWeight="bold">
						{t('customer_support')}{' '}
						<MdInfoOutline
							onClick={openModal}
							css={(theme: Theme) => css`
								cursor: pointer;
								color: ${theme.colors.primary};
							`}
						/>
					</Text>
				</Flex>
			)}
		>
			{closeModal => (
				<Paper
					p={3}
					css={css`
						border-radius: 3px;
						box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
						border: 0;
					`}
				>
					<TitleText>{t('customer_support')}</TitleText>
					<Text>{t('customer_support_text_01')}</Text>
					<Text>
						{t('customer_support_text_02')}{' '}
						<Link to="/homepage/company" target="_blank">
							{t('customer_support_text_02b')}
						</Link>
					</Text>

					<Button variant="outlined" mt={3} onClick={closeModal} mr="auto">
						{t('back')}
					</Button>
				</Paper>
			)}
		</ModalDialog>
	);
};

export const AdditionalPackagesMoreInfoDialog: React.FC<{
	isOffers: boolean;
	isReveals: boolean;
}> = ({ isOffers, isReveals }) => {
	const { t } = useTranslation('components/tiles/product_tab/index/');
	return (
		<ModalDialog
			label="info"
			control={openModal => (
				<MdInfoOutline
					onClick={openModal}
					css={(theme: Theme) => css`
						cursor: pointer;
						margin-left: 4px;
						color: ${theme.colors.primary};
					`}
				/>
			)}
		>
			{closeModal => (
				<Paper
					p={3}
					css={css`
						border-radius: 3px;
						box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
						border: 0;
					`}
				>
					{isOffers && (
						<>
							<TitleText>{t('extension_ads')}</TitleText>
							<Text>{t('extensions_text_01')}</Text>
							<Text>{t('extensions_text_02_offers')}</Text>
						</>
					)}

					{isReveals && (
						<>
							<TitleText>{t('extension_reveals')}</TitleText>
							<Text>{t('extensions_text_01')}</Text>
							<Text>{t('extensions_text_02_reveals')}</Text>
						</>
					)}

					<Button variant="outlined" onClick={closeModal} mr="auto" mt={3}>
						{t('back')}
					</Button>
				</Paper>
			)}
		</ModalDialog>
	);
};
